var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5833 20.5834H5.41667V8.66671H20.5833M17.3333 1.08337V3.25004H8.66667V1.08337H6.5V3.25004H5.41667C4.21417 3.25004 3.25 4.21421 3.25 5.41671V20.5834C3.25 21.158 3.47827 21.7091 3.8846 22.1154C4.29093 22.5218 4.84203 22.75 5.41667 22.75H20.5833C21.158 22.75 21.7091 22.5218 22.1154 22.1154C22.5217 21.7091 22.75 21.158 22.75 20.5834V5.41671C22.75 4.84207 22.5217 4.29097 22.1154 3.88464C21.7091 3.47831 21.158 3.25004 20.5833 3.25004H19.5V1.08337M18.4167 13H13V18.4167H18.4167V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar-white.e20fc9b33b7f49aae1eff93c59fd07b2.svg";
export { ForwardRef as ReactComponent };